export const selectCurrentWeaveUser = (store) => store?.auth?.user?.user_id ?? '';
